export default __webpack_public_path__ + "static/media/monstera.6257bc6b.jpg";